(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  const init = root => {
    root.querySelectorAll('[data-footer-menu]').forEach(menu => {
      if (menu.dataset.footerReady) return;
      menu.dataset.footerReady = 'true';
      const summary = menu.querySelector('summary');
      const sync = () => {
        menu.open = desktop.matches;
        summary.tabIndex = desktop.matches ? -1 : 0;
      };
      summary.addEventListener('click', event => {
        if (desktop.matches) event.preventDefault();
      });
      desktop.addEventListener('change', sync);
      sync();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
function initializeContactWhatsapp(root) {
  root.querySelectorAll('[data-connect-whatsapp]').forEach((link) => {
    if (link.dataset.whatsappReady) return;
    const form = link.closest('form');
    const number = link.dataset.whatsappNumber.replace(/\D/g, '');
    if (!form || !/^\d{7,15}$/.test(number)) return;
    const field = (key) => form.elements.namedItem(`contact[${key}]`);
    const updateLink = () => {
      const lines = [link.dataset.messageIntro, ''];
      ['name', 'email', 'phone', 'topic', 'body'].forEach((key) => {
        const input = field(key);
        const value = input?.value.trim();
        const labelKey = key === 'body' ? 'messageLabel' : `${key}Label`;
        if (value) lines.push(`${link.dataset[labelKey]}: ${value}`);
      });
      const url = new URL(`https://wa.me/${number}`);
      url.searchParams.set('text', lines.join('\n'));
      link.href = url.href;
    };
    link.addEventListener('click', (event) => {
      for (const input of form.elements) {
        if (input.willValidate && !input.reportValidity()) {
          event.preventDefault();
          return;
        }
      }
      updateLink();
    });
    form.addEventListener('input', updateLink);
    form.addEventListener('change', updateLink);
    updateLink();
    link.dataset.whatsappReady = 'true';
    link.hidden = false;
  });
}
initializeContactWhatsapp(document);
document.addEventListener('shopify:section:load', (event) => initializeContactWhatsapp(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paw-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = section => {
    if (section.dataset.campaignReady) return;
    section.dataset.campaignReady = 'true';
    const rail = section.querySelector('[data-campaign-rail]');
    const prev = section.querySelector('[data-campaign-prev]');
    const next = section.querySelector('[data-campaign-next]');
    if (!rail || !prev || !next) return;
    const update = () => {
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    const move = direction => {
      const slide = rail.querySelector('.paw-campaign__slide');
      const gap = parseFloat(getComputedStyle(rail).gap) || 0;
      rail.scrollBy({left:direction * (slide.getBoundingClientRect().width + gap),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(rail);
    section.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest('.paw-campaign__slide');
      if (slide) rail.scrollTo({left:slide.offsetLeft,behavior:'instant'});
    });
    update();
  };
  const initAll = root => root.querySelectorAll('[data-paw-campaign]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paw-image-comparison"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('paw-image-comparison')){
  customElements.define('paw-image-comparison',class extends HTMLElement{
    connectedCallback(){
      const slider=this.querySelector('input[type="range"]');
      if(!slider||this.dataset.ready)return;
      this.dataset.ready='true';
      const update=()=>this.style.setProperty('--split',slider.value+'%');
      slider.addEventListener('input',update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
